import Vue from 'vue'
import MentorComments from 'mentor-comments.vue'
import store from 'check-store.js'

document.addEventListener('DOMContentLoaded', () => {
  const selector = '#js-mentor-comments'
  const mentorComments = document.querySelector(selector)
  if (mentorComments) {
    const mentorCommentableId = mentorComments.getAttribute('data-mentor-commentable-id')
    const mentorCommentableType = mentorComments.getAttribute('data-mentor-commentable-type')
    const currentUserId = Number(mentorComments.getAttribute('data-current-user-id'))
    const currentUser = window.currentUser
    new Vue({
      store,
      render: (h) =>
        h(MentorComments, {
          props: {
            mentorCommentableId: mentorCommentableId,
            mentorCommentableType: mentorCommentableType,
            currentUserId: currentUserId,
            currentUser: currentUser
          }
        })
    }).$mount(selector)
  }
})
